import React from 'react';
import { Link, useLocation } from 'react-router';
import {
  DateUtil,
  CardHeader,
  SmallHeader,
  HeaderLink,
  Gutter,
  CompanyLogo,
  Layout,
  LayoutItem,
  ParagraphHeader,
  Badge,
  Visible,
  LogoUtil,
} from '@axiom/ui';
import type { CandidateWorkFeedItem } from '@axiom/validation';

import type { WorkFeedViewsType } from '../../utils/WorkFeedUtil';
import { WorkFeedUtil } from '../../utils/WorkFeedUtil';

export const WorkFeedCardHeader = ({
  workFeedItem,
  view,
  name = 'WORK_FEED_CARD_HEADER',
}: {
  workFeedItem: CandidateWorkFeedItem;
  view: WorkFeedViewsType;
  name?: string;
}) => {
  const location = useLocation();

  return (
    <CardHeader
      name={name}
      Badge={
        !!workFeedItem.candidateIsInterested && (
          <Badge
            name="INTERESTED_STATUS"
            background="light blue"
            flush="right"
          >{`Interested${workFeedItem.addedToPoolAt ? ` ${DateUtil.displayDateFullYearShortMonth(workFeedItem.addedToPoolAt)}` : ''}`}</Badge>
        )
      }
    >
      <Layout position="middle" horizontalGutter="16px" wrap>
        <Visible only="largeScreen tablet">
          <LayoutItem>
            <CompanyLogo
              name="COMPANY_LOGO_IMAGE"
              src={LogoUtil.getUrl(workFeedItem.account?.website)}
              alt={workFeedItem.account?.calculatedName}
            />
          </LayoutItem>
        </Visible>

        <LayoutItem>
          <HeaderLink>
            <SmallHeader name="JOB_NAME">
              {WorkFeedUtil.isSinglePageView(view) ? (
                workFeedItem.opportunity.jobName
              ) : (
                <Link
                  data-test="SPV_LINK"
                  to={`../${workFeedItem.id}`}
                  state={{ from: location }}
                >
                  {workFeedItem.opportunity.jobName}
                </Link>
              )}
            </SmallHeader>
          </HeaderLink>
          <Gutter bottom="8px" />
          <ParagraphHeader name="ACCOUNT_NAME">
            {workFeedItem.opportunity.accountName}
          </ParagraphHeader>
        </LayoutItem>
      </Layout>
    </CardHeader>
  );
};
